import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import styled from "styled-components";
import { BackButton, Title, Spinner } from "components";
import { CrearGrupoForm } from "components/Forms";
import { Mutation } from "hooks/useMutation";
import { useGetPeriodo } from "hooks/useRequest";
import { crearGrupo } from "./mutations";
import moment from "moment";
import { isEidu } from "utilites/periodoTypes";

export default function CrearGrupo() {
  const mutation = Mutation(crearGrupo);
  const history = useHistory();

  const { search } = useLocation();
  const { periodo } = queryString.parse(search);
  const periodoId = Number(periodo);

  const { data: periodoData, isLoading } = useGetPeriodo({
    id: periodoId,
  });
  const isEiduPeriodo = isEidu(periodoData?.tipoPeriodo?.id);

  const onFinish = (values: any) => {
    const formattedValues = {
      nombre: values.name,
      horario: isEiduPeriodo ? "" : values.day,
      tipoSede: isEiduPeriodo ? false : values.type,
      cupo: values.qty,
      periodoMatricula: periodo,
      horaEntrada: isEiduPeriodo
        ? ""
        : moment(values.startTime).format("h:mm a"),
      horaSalida: isEiduPeriodo
        ? ""
        : moment(values.endTime).format("h:mm a"),
      profesor: values.profesor,
    };
    /*@ts-ignore*/
    mutation.mutate(formattedValues);
  };

  const goBack = () => {
    history.push({
      pathname: "/admin/periodo-matricula",
      search: `?periodo=${periodo}`,
    });
  };

  useEffect(() => {
    if (mutation.isSuccess) {
      goBack();
    }
  }, [mutation, history, periodo]);

  return (
    <PageContainer>
      <BackButton text="Inicio" onClick={() => goBack()} link="/admin" />
      <Title title={isEiduPeriodo ? "Nuevo Taller" : "Nuevo Grupo"} />
      {isLoading ? (
        <Spinner isLoading title="Cargando periodo" />
      ) : (
        <CrearGrupoForm
          onCancel={goBack}
          onFinish={onFinish}
          isEidu={isEiduPeriodo}
          submitButtonText={isEiduPeriodo ? "Crear Taller" : "Crear Grupo"}
        />
      )}
    </PageContainer>
  );
}

const PageContainer = styled.div`
  @media (max-width: 1200px) {
    margin-bottom: 45px;
    padding-right: 86px;
    padding-left: 86px;
  }
`;
